/*
 * @Author: bbqin
 * @Date: 2021-08-24 15:49:51
 * @LastEditTime: 2022-03-05 10:51:08
 * @LastEditors: bbqin
 * @Description: 啥功能呢
 * @FilePath: \Platform_Front\src\platform\components\TransferTable\pagination.js
 * 这锅我不背
 */

import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { Select, Pagination, Tooltip, Input } from '@platform/base';
import { getSysFieldid, getMultiLang } from '@platform/api';
const MAX_BUTTONS = 5;
const Option = Select.Option;
import './pagination.less';
import PropTypes from "prop-types";

export default function pagination(Table) {
    return class PaginationWrapper extends Component {
        static defaultProps = { pageInfo: {} };

        static propTypes = {
            pageInfo: PropTypes.object,
            pageInfoChange: PropTypes.function,
        };

        constructor(props) {
            super(props);
            this.state = {
                hideSelectDropdown: false,
                //pageInfo: this.props.pageInfo,
                json: {},
                pageSizeVal: '',
            };
            this.options = ['10', '20', '50', '100'];

            this.selectDom = null;

        }

        UNSAFE_componentWillMount() {
            //加载多语
            let callback = json => {
                let pageSizeVal = this.props.pageInfo && this.props.pageInfo.pageSize;
                this.setState({
                    json,
                    pageSizeVal,
                });
            };
            getMultiLang({ moduleId: 'table_lib_pagination', callback });
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.pageInfo && nextProps.pageInfo.pageSize) {
                if (!this.props.pageInfo || nextProps.pageInfo.pageSize != this.props.pageInfo.pageSize) {
                    let json = this.state.json;
                    this.setState({ pageSizeVal: nextProps.pageInfo.pageSize });
                }
            }

        }

        //pageIndex事件
        pageIndexChange = val => {
            let { pageInfoChange, pageInfo } = this.props;
            let { total, pageSize } = pageInfo;
            //更新 pageInfo
            let newPageInfo = {
                ...pageInfo,
                pageIndex: val,
                totalPage: Math.ceil(total / pageSize),
            };

            if (typeof pageInfoChange === 'function') {
                pageInfoChange(newPageInfo);
            }
        };

        // pageSize事件
        pageSizeChange = val => {
            let { pageInfoChange, pageInfo } = this.props;
            let { total } = pageInfo;
            let newPageInfo = {
                ...pageInfo,
                pageIndex: 1,
                pageSize: +val,
                totalPage: Math.ceil(total / val),
            };

            if (typeof pageInfoChange === 'function') {
                pageInfoChange(newPageInfo);
            }
        };

        render() {
            let { hideSelectDropdown, json } = this.state;
            let { pageInfo, checkNum, showPagination = false, showPageSizeOption = true, maxPageSize = 5000 } = this.props;
            let { pageSize, total, totalPage, pageIndex } = pageInfo;
            return (
                <React.Fragment>
                    <Table {...this.props} />
                    {showPagination && <div
                        className="transfer-table-pagination-wrapper"
                        fieldid={getSysFieldid("pagination-div")}
                    >
                        <div className="pagination-size">

                            {!!+total && (
                                <span className="pagination-total">
                                    {/* {json['pagination002']}<span>{total}</span>{json['pagination003']} */}
                                    {checkNum && <span style={{ marginLeft: '1px' }}>&nbsp;{json['pagination004']}{checkNum()}{json['pagination003']}</span>}
                                </span>
                            )}
                        </div>
                        <div className="pagination">
                            <Pagination
                                prev
                                next
                                boundaryLinks
                                pageSize={this.state.pageSizeVal}
                                total={total}
                                // items={Number(totalPage || 1)}
                                /*分页器按钮：最多显示7个按钮, 当页数>7时 左侧最多显示5个按钮 等于7时 左侧最多显示6个按钮*/
                                maxButtons={Number(totalPage || 1) === 7 ? 6 : MAX_BUTTONS}
                                current={Number(pageIndex)}
                                showSizeChanger={true}
                                pageSizeOptions={[10, 20, 50, 100]}
                                onPageSizeChange={(index, pageSize) => {
                                    // console.log(index, pageSize);
                                    this.setState({ pageSizeVal: pageSize });
                                    this.pageSizeChange(pageSize);
                                }}
                                onChange={this.pageIndexChange}
                            />
                        </div>
                    </div >}
                </React.Fragment>
            );
        }
    };
}